import { ChevronRight } from "lucide-react";
import { useWorld } from "@/context/WorldContext";
import { useFold } from "@/lib/collections";
import { CollectionMenu } from "@/components/CollectionBits";

export const CollectionSection = ({ id, name, col, count, children }) => {
  const { basePath, readOnly } = useWorld();
  const [folded, toggle] = useFold(`${basePath}:cat:${id}`);
  return (
    <section className="rounded-2xl border border-line bg-panel/40" data-testid={`collection-section-${id}`}>
      <div className="flex items-center gap-2 px-4 py-3">
        <button type="button" onClick={toggle} aria-expanded={!folded} data-testid={`collection-toggle-${id}`} className="flex-1 min-w-0 flex items-center gap-2 text-left group">
          <ChevronRight className={`w-4 h-4 text-slate-500 transition-transform duration-200 ${folded ? "" : "rotate-90"}`} />
          <h2 className={`font-display text-2xl truncate transition-colors group-hover:text-amber-200 ${col ? "text-amber-50" : "text-slate-300 italic"}`}>{name}</h2>
          <span className="text-slate-600 font-code text-xs" data-testid={`collection-count-${id}`}>{count}</span>
        </button>
        {col && !readOnly && <CollectionMenu col={col} />}
      </div>
      {!folded && <div className="px-4 pb-4">{count ? children : <p className="text-sm text-slate-500 italic px-1 pb-2">No entries here yet. Add some from an entry's editor.</p>}</div>}
    </section>
  );
};
